<template>
  <div >
      <MainDGDetail :data="shippingRequest" :removeStatusInfo="removeStatusInfo" :showActivityHistory="showActivityHistory"></MainDGDetail>
  </div>
</template>

<script>

import MainDGDetail from "./MainDGDetails";
import PrintCertificateModal from "./PrintCertificateModal";

export default {
  name: "MainShippingDetail",
  components: { MainDGDetail },
  props: {
    shippingRequest: { type: Object, required: true },
    removeStatusInfo: Boolean,
    showActivityHistory: Boolean
  },

  methods: {
    
    printCertificate: function() {
      this.$modal.open({
        parent: this,
        component: PrintCertificateModal,
        hasModalCard: true,
        props: {
          data: this.shippingRequest
        }
      });
    }
  }
};
</script>
<style scoped></style>
